import { useContext, useEffect, useState } from 'react';

import { useNavigate, useLocation } from 'react-router-dom';

import { TwilioContext } from '../../../context-providers/TwilioContext';
import { AgentContext } from '../../../context-providers/AgentContext';
import { isErrorLog } from '../../../utils';
import { logService } from '../../../services';
import { buildModalUrl, ModalName } from '../../../routes';

export const useHeaderActions = () => {
  const { connect, disconnect, isStatusLocked } = useContext(TwilioContext);
  const { identity, phoneNumber } = useContext(AgentContext);
  const [errorCount, setErrorCount] = useState<number>(0);
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname + location.search;

  useEffect(() => {
    const onErrorLog = (log: unknown) => {
      if (isErrorLog(log)) {
        setErrorCount((prevCount) => prevCount + 1);
      }
    };

    logService.on('log', onErrorLog);

    return () => {
      logService.off('log', onErrorLog);
    };
  }, []);

  const showLogs = () => {
    navigate(buildModalUrl(currentPath, { modal: ModalName.Logs }));
    setErrorCount(0);
  };

  const showSettings = () => {
    navigate(buildModalUrl(currentPath, { modal: ModalName.Settings }));
  };

  const onConnect = () => {
    if (identity && phoneNumber) {
      connect(identity, phoneNumber, 'online');
    }
  };

  const onDial = () => {
    navigate(buildModalUrl(currentPath, { modal: ModalName.Dialer }));
  };

  return {
    errorCount,
    showLogs,
    showSettings,
    onConnect,
    onDial,
    disconnect,
    hasConnectionInfo: Boolean(identity && phoneNumber),
    isStatusLocked,
  };
};
